import { B200, N0, N10, N100, N20, N200, N30, N40, N70, N900, R400 } from '@atlaskit/theme/colors';
export const disabledBackground = `var(--ds-background-disabled, ${N20})`;
export const disabledBorder = `var(--ds-border-disabled, ${N40})`;
export const invalidBorderColor = `var(--ds-border-danger, ${R400})`;
export const defaultBorderColor = `var(--ds-border-input, ${N100})`;
export const defaultBorderColorFocus = `var(--ds-border-focused, ${B200})`;
export const defaultBackgroundColor = `var(--ds-background-input, ${N10})`;
export const defaultBackgroundColorHover = `var(--ds-background-input-hovered, ${N30})`;
export const defaultBackgroundColorFocus = `var(--ds-background-input-pressed, ${N0})`;
export const subtleBorderColorHover = "var(--ds-border-input, transparent)";
export const placeholderTextColor = `var(--ds-text-subtlest, ${N200})`;
export const textColor = `var(--ds-text, ${N900})`;
export const disabledTextColor = `var(--ds-text-disabled, ${N70})`;
export const transparent = 'transparent';